import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Breadcrumbs from "../components/Breadcrumbs";

// Utils
import { countData } from "../../utils/SamuiUtils";

function Warehouse() {
  const [counts, setCounts] = useState({});
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    const fetchCounts = async () => {
      const tables = ["WH_ITEM_Onhand", "WHDoc_H"];
      const countsData = {};

      for (const table of tables) {
        countsData[table] = await countData(table, "");
      }

      setCounts(countsData);
    };

    fetchCounts();
  }, []);

  const renderCard = (category, icon, table, additionalInfo, path) => (
    <div
      className="col-sm-6 col-md-2"
      style={{ cursor: "pointer" }}
      onClick={() => window.location.replace(path)}
    >
      <div className="card card-stats card-round">
        <div className="card-body d-flex flex-column align-items-center">
          <div className="col-icon mb-3">
            <div
              className="icon-big text-center icon-secondary bubble-shadow-small"
              style={{ backgroundColor: "orange" }}
            >
              <i className={icon} />
            </div>
          </div>
          <div className="col col-stats text-center">
            <div className="numbers">
              <p className="card-category">{category}</p>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li style={{ color: "orange" }}>
                  {counts[table] !== undefined
                    ? `${counts[table]} รายการ`
                    : "Loading..."}
                </li>
              </ul>
            </div>
          </div>
          {/* <div className="col col-stats text-center">
            <div className="row">
              {additionalInfo.map((item, index) => (
                <div key={index} className="col-4" style={{ color: 'gray', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <i className="far fa-clock" aria-hidden="true" style={{ fontSize: '15px', marginRight: '5px' }}></i>
                  <span>{item}</span>
                </div>
              ))}
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );

  return (
    <div className="Warehouse">
      <button
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        className="btn btn-toggle-sidebar"
        style={{
          position: "fixed",
          top: "1rem",
          left: isSidebarOpen ? "190px" : "-15px",
          zIndex: 1001,
          background: "transparent",
          border: "none",
          color: "#EF6C00",
          fontSize: "20px",
        }}
      >
        {isSidebarOpen ? "✖" : "☰"}
      </button>
      <div className="wrapper">
        <Sidebar
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
        />
        <div
          className={`main-panel ${
            isSidebarOpen ? "sidebar-open" : "sidebar-closed"
          }`}
        >
          <div className="container">
            <div className="page-inner">
              <div className="page-header d-flex justify-content-between align-items-center">
                <Breadcrumbs
                  page={"คลัง"}
                  items={[{ name: "คลัง", url: "/warehouse" }]}
                />
              </div>
              <div className="row">
                {renderCard(
                  "คลัง",
                  "far fa-file-alt",
                  "WH_ITEM_Onhand",
                  [5, 0, 0],
                  "/warehouse-stock"
                )}
                {renderCard(
                  "จัดการเอกสารงานคลัง",
                  "fas fa-file-invoice",
                  "WHDoc_H",
                  [5, 0, 0],
                  "/treasury-documents"
                )}
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default Warehouse;
